import { FC, useContext } from 'react';

import useTimeZone from 'hooks/use-timezone';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryStartDate: FC<{ className?: string }> = ({ className = '' }) => {
  const { dateInputToUtc, utcToZonedDate } = useTimeZone();
  const { expirationDate, startDate, setStartDate } = useContext(RedeliveryContext);

  return (
    <div className={`text-field ${className}`}>
      <input
        className="h-100 w-100"
        data-cy="redelivery-start-date-input"
        max={utcToZonedDate(expirationDate)}
        onChange={e => setStartDate(dateInputToUtc(e.target.value))}
        required
        ref={node => node?.classList.toggle('blank', !startDate)}
        type="date"
        value={utcToZonedDate(startDate)}
      />
      <label>START DATE</label>
    </div>
  );
};

export default RedeliveryStartDate;
